import { gql } from "graphql-request";

export const GET_RECOVERY_FLOW_CONFIG = gql`
query GetRecoveryFlowConfig {
  getRecoveryFlowConfig {
    useNewRecoveryFlow
  }
}
`;
